// Module
var code = "<thead class=\"grid-with-functions\"> <tr> <th id=\"column1header\" class=\"grid-col1\">Field</th> <th id=\"column2header\" class=\"grid-col2\"></th> <th id=\"column3header\" class=\"grid-col3\"></th> <th class=\"grid-col4\"></th> </tr> </thead> <tbody class=\"with-function grid-with-functions\"></tbody> ";
// Exports
export default code;